import GameFieldArea from './GameFieldArea';

const Game = () => {

  return (
    <div className="game-section">
        <GameFieldArea />
    </div>
  );
}

export default Game;
